var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShutterPeace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0002 1.6648C23.407 1.23135 21.7305 1 20 1C9.50659 1 1 9.50659 1 20C1 28.0531 6.01016 34.9361 13.0835 37.7019C5.70013 32.8756 8.57827 20 19.8528 20C31.6651 20 33.1499 5.86704 25.0002 1.6648ZM40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z",
    fill: "#FEFEF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShutterPeace);
export default __webpack_public_path__ + "static/media/shutter_peace.6dbde5b3.svg";
export { ForwardRef as ReactComponent };